import { OwnerModel } from 'src/app/model/ownerModel.model';
import { RefAddressModel } from 'src/app/model/refAddressModel.model';
import { ParcelModel } from '../../../model/parcelModel.model';
import { AddressModel } from '../../shared/model/addressModel.model';
import { HTML_ELEMENT } from '../../shared/model/htmlElements.const';
import { ConditionType } from '../models/apo.const';
import { ApoQueryable } from '../models/apoRecord.model';
import { APOSearchData } from '../models/APOSearchResult.model';

export const getAddressDescription = (addrModel: AddressModel): string => {
        let addressCardData = new Array<string>();
        addressCardData.push(addrModel.streetPrefix);
        addressCardData.push(addrModel.houseNumberStart?.toString());
        addressCardData.push(addrModel.streetName);
        addressCardData.push(addrModel.streetSuffix);
        addressCardData.push(addrModel.unitStart);
        addressCardData.push(addrModel.unitEnd ? ` - ${addrModel.unitEnd}` : '');
        addressCardData.push(addrModel.streetDirection);
        addressCardData.push(addrModel.addressLine1);
        addressCardData.push(addrModel.addressLine2);
        addressCardData = addressCardData.filter(n => n && n.trim());
        if(addressCardData && addressCardData.length > 0 ){
          addressCardData[addressCardData.length-1] = `${addressCardData[addressCardData.length-1]},`;
        }
        addressCardData.push(addrModel.city ? `${addrModel.city},` : '');
        addressCardData.push(addrModel.state ? `${addrModel.state},` : '');
        addressCardData.push(addrModel.zip);
  return addressCardData.filter(n => n && n.trim()).join(' ');
};


export const getAddressSuggestion = (addrModel: AddressModel): string => {
  const addressCardData = new Array<string>();
  addressCardData.push(addrModel.streetPrefix);
  addressCardData.push(addrModel.houseNumberStart?.toString());
  addressCardData.push(addrModel.streetName);
  addressCardData.push(addrModel.streetSuffix);
  addressCardData.push(addrModel.streetDirection);
  return addressCardData.filter(n => n && n.trim()).join(', ');
};
export const getParcelSuggestion = (parcelModel: ParcelModel): string => {
  const prcl = parcelModel.parcelNumber;
  return prcl;
};

export const getRefAddressStreetDescription = (refAddr: RefAddressModel): string => {
    const addressCardData = new Array<string>();
    addressCardData.push(refAddr.streetPrefix);
    addressCardData.push(refAddr.houseNumberStart?.toString());
    addressCardData.push(refAddr.streetName);
    addressCardData.push(refAddr.streetSuffix);
    addressCardData.push(refAddr.unitStart);
    addressCardData.push(refAddr.unitEnd ? ' - '+refAddr.unitEnd : '');
    addressCardData.push(refAddr.streetDirection);
    addressCardData.push(refAddr.addressLine1);
    addressCardData.push(refAddr.addressLine2);
  return addressCardData.filter(n => n && n.trim()).join(' ');
};

export const getOwnerNameDescription = (ownrModel: OwnerModel): string => {
  const ownerDesc = new Array<string>();
  ownerDesc.push(ownrModel.ownerFullName
    ?? (ownrModel.mailFullName
      ?? `${ownrModel.ownerFirstName ?? ''} ${ownrModel.ownerLastName ?? ''}`));
  return ownerDesc.filter(n => n && n.trim()).join(' ').trim();
};

export const getOwnerSuggestion = (ownrModel: OwnerModel): string => {
  const ownr = getOwnerNameDescription(ownrModel);
  return ownr;
};

export const getOwnerAddressDescription = (ownrModel: OwnerModel): string => {
  const ownerDesc = new Array<string>();
  const csZip = new Array<string>();
  if (ownrModel.mailAddress1 === null || ownrModel.mailAddress1 === undefined) {
    ownerDesc.push(ownrModel.address1 === null
      || ownrModel.address1 === undefined ? ''
      : HTML_ELEMENT.lineBreak + ownrModel.address1 + HTML_ELEMENT.lineBreak);

    ownerDesc.push(ownrModel.address2 === null || ownrModel.address2 === undefined? '': ownrModel.address2 + HTML_ELEMENT.lineBreak);
  } else {
    ownerDesc.push(HTML_ELEMENT.lineBreak + ownrModel.mailAddress1+ HTML_ELEMENT.lineBreak);
    ownerDesc.push(ownrModel.mailAddress2 === null
      || ownrModel.mailAddress2 === undefined? ''
        : ownrModel.mailAddress2 + HTML_ELEMENT.lineBreak);
  }
  csZip.push(ownrModel.mailCity ?? ownrModel.city);
  csZip.push(ownrModel.mailState ?? ownrModel.state);
  csZip.push(ownrModel.mailZip ?? ownrModel.zip);
  ownerDesc.push(csZip.filter(n => n && n.trim()).join(', '));
  return ownerDesc.filter(n => n && n.trim()).join('').trim();
};

export const getOwnerDescription = (ownrModel: OwnerModel): string => {
  const name = getOwnerNameDescription(ownrModel);
  const addr = getOwnerAddressDescription(ownrModel);

  return `${name} ${addr}`.trim();
};

export const getParcelDescription = (parcelModel: ParcelModel): string => {
  const parcelDesc = new Array<string>();
  parcelDesc.push(parcelModel.parcelNumber);
  parcelDesc.push(parcelModel.parcelStatus);
  return parcelDesc.filter(n => n && n.trim()).join(', ');
};

export const apoHasCondition = (col: ApoQueryable, condType: ConditionType): boolean => {
  let flag = false;
  if (col && col.hasOwnProperty('hightestCondition')) {
    flag = col.hightestCondition?.impactCode.toUpperCase() === condType;
  }

  return flag;
};

export const convertRefAddressModeltoAddressModel =
  (addrModel: RefAddressModel): AddressModel => {
    const addressModel = new AddressModel();
    Object.assign<AddressModel, RefAddressModel>(addressModel, addrModel);
    if(!addressModel.addressId || addressModel.refAddressId === -1){
      addressModel.addressId = addrModel.refAddressId;
    }
    return addressModel;
  };

export const convertAddressModeltoRefAddressModel =
  (addrModel: AddressModel): RefAddressModel => {
    const refModel = new RefAddressModel();
    Object.assign<RefAddressModel,AddressModel>(refModel, addrModel);
    if(!refModel.refAddressId|| refModel.refAddressId === -1){
      refModel.refAddressId = addrModel.refAddressId;
    }
    return refModel;
  };

export const getApoDescriptor = (apoRecord: ApoQueryable|APOSearchData): string => {
  if (apoRecord.hasOwnProperty('addressId')){
    return getAddressDescription(apoRecord as AddressModel);
  } else if (apoRecord.hasOwnProperty('parcelNumber')){
    return getParcelDescription(apoRecord as ParcelModel);
  } else if (apoRecord.hasOwnProperty('ownerNumber')){
    return getOwnerDescription(apoRecord as OwnerModel);
  } else if (apoRecord.hasOwnProperty('Name')){
    return (apoRecord as APOSearchData).Name;
  }
  return 'Record';
};
